import { useModelCompareTranslation } from "constants/modelCompareData/translations/useModelCompareTranslation";import { useMenu } from "@ubnt/store.core/lib/contexts/MenuContext";
import { BadgeVariants } from "@ubnt/store.core/lib/components/Badge/Badge.types";
import * as S from "../../../CompareTable.styles";
import type { BadgesProps } from "./Badges.types";

export const Badges = ({ product }: BadgesProps) => {
  const { formatMessage } = useModelCompareTranslation();
  const { storeId } = useMenu();

  // If product is new, render new badge and nothing else
  if (product.isNew) {
    return <S.Badge variant="lightGreen">{formatMessage("New")}</S.Badge>;
  }

  if (!product?.customBadges?.length) {
    return null;
  }

  product.customBadges?.map((badge, i) => {
    const value =
      badge.value.type === "translation"
        ? formatMessage(
            typeof badge.value.value === "string"
              ? badge.value.value
              : badge.value.value(storeId),
          )
        : typeof badge.value.value === "string"
          ? badge.value.value
          : badge.value.value(storeId);
    return (
      <S.Badge key={i} variant={badge.variant || BadgeVariants.lightGrey}>
        {value}
      </S.Badge>
    );
  });

  return null;
};
